'use client';

import Link from 'next/link';
import Image from 'next/image';
import React from 'react';
import { PostNode } from '@/types/global';

interface HeroBlogProps {
    posts: PostNode[];
}

const HeroBlog: React.FC<HeroBlogProps> = ({ posts }) => {
    return (
        <section className={'customContainer'}>
            <div className='grid grid-cols-12 gap-2 lg:gap-4'>
                <div
                    className={
                        'relative group col-span-12 overflow-hidden rounded-lg lg:rounded-2xl border dark:border-white/15 lg:col-span-6'
                    }
                >
                    {posts?.slice(0, 1).map((post) => (
                        <Link href={`/${post.slug}`} key={post.databaseId}>
                            {post.featuredImage && (
                                <Image
                                    src={post?.featuredImage?.node?.sourceUrl || ''}
                                    alt={post?.featuredImage?.node?.altText || post?.title}
                                    title={post?.featuredImage?.node?.title || post?.title}
                                    width={'1200'}
                                    height={'800'}
                                    loading='eager'
                                    className={
                                        'aspect-video size-full before:absolute before:z-[1] before:size-full before:bg-gradient-to-t before:from-primary/70 before:content-[""] '
                                    }
                                />
                            )}
                            <span
                                className={
                                    'absolute text-white bottom-1 lg:bottom-2 transition-all inset-x-0 z-1 px-4 max-lg:text-xs text-center'
                                }
                            >
                                {post?.title}
                            </span>
                        </Link>
                    ))}
                </div>
                <div className={'col-span-12 grid grid-cols-12 gap-2 lg:gap-4 lg:col-span-6'}>
                    {posts?.slice(1, 5).map((post) => (
                        <div
                            className={
                                'relative group col-span-6 overflow-hidden rounded-lg lg:rounded-2xl border dark:border-white/15'
                            }
                            key={post.databaseId}
                        >
                            <Link href={`/${post.slug}`} key={post.databaseId}>
                                {post.featuredImage && (
                                    <Image
                                        src={post?.featuredImage?.node?.sourceUrl || ''}
                                        alt={post?.featuredImage?.node?.altText || post?.title}
                                        title={post?.featuredImage?.node?.title || post?.title}
                                        loading='eager'
                                        width={'1200'}
                                        height={'800'}
                                        className={
                                            'aspect-video size-full before:absolute before:z-[1] before:size-full before:bg-gradient-to-t before:from-primary/70 before:content-[""]'
                                        }
                                    />
                                )}
                            </Link>
                            <span
                                className={
                                    'absolute bottom-0 text-white line-clamp-1 mb-2 max-lg:bg-gradient-to-t from-primary-dark inset-x-0 z-1 px-2 max-lg:text-[9px] text-xs text-center'
                                }
                            >
                                {post?.title}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HeroBlog;
